export type ITypeNotification = "roadload" | "portal";
export enum TypeNotificationEnum {
  ROADLOAD = "roadload",
  PORTAL = "portal",
}
export const { ROADLOAD, PORTAL } = TypeNotificationEnum;
